const NAMESPACE = "USERS";
const actionType = type => `${NAMESPACE}_${type}`;

export const usersConstants = {
	ADD_USER_SUBMIT_REQUEST: "ADD_USER_SUBMIT_REQUEST",
	ADD_USER_SUBMIT_SUCCESS: "ADD_USER_SUBMIT_SUCCESS",
	ADD_USER_SUBMIT_FAILURE: "ADD_USER_SUBMIT_FAILURE",

	UPDATE_GENERAL_INFO_REQUEST: "USER_UPDATE_GENERAL_INFO_REQUEST",
	UPDATE_GENERAL_INFO_SUCCESS: "USER_UPDATE_GENERAL_INFO_SUCCESS",
	UPDATE_GENERAL_INFO_FAILURE: "USER_UPDATE_GENERAL_INFO_FAILURE",

	UPDATE_LINKS_REQUEST: "USER_UPDATE_LINKS_REQUEST",
	UPDATE_LINKS_SUCCESS: "USER_UPDATE_LINKS_SUCCESS",
	UPDATE_LINKS_FAILURE: "USER_UPDATE_LINKS_FAILURE",

	EDIT_USER_SUBMIT_REQUEST: "USERS_EDIT_USER_SUBMIT_REQUEST",
	EDIT_USER_SUBMIT_SUCCESS: "USERS_EDIT_USER_SUBMIT_SUCCESS",
	EDIT_USER_SUBMIT_FAILURE: "USERS_EDIT_USER_SUBMIT_FAILURE",

	SET_ACTIVE_USER_ID: actionType("SET_ACTIVE_USER_ID"),
};
